import { render } from "./ActiveCases.vue?vue&type=template&id=04ae2bc7"
import script from "./ActiveCases.vue?vue&type=script&lang=js"
export * from "./ActiveCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/ActiveCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04ae2bc7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04ae2bc7', __exports__)) {
    console.log('reload')
    api.reload('04ae2bc7', __exports__)
  }
  
  module.hot.accept("./ActiveCases.vue?vue&type=template&id=04ae2bc7", () => {
    console.log('re-render')
    api.rerender('04ae2bc7', render)
  })

}


export default __exports__